import React from 'react';
import withIcon from '../utilities/withIcon';

const IconSlidersVert = () => {
  return (
    <g>
      <path d="M14.417 10.2363H9.6162a.75.75 0 0 1 0-1.5h4.8008a.75.75 0 1 1 0 1.5zM12.1128 15.8057a.75.75 0 0 1-.75-.75V11.791a.75.75 0 0 1 1.5 0v3.2647a.75.75 0 0 1-.75.75z" />
      <path d="M12.1128 10.2363a.75.75 0 0 1-.75-.75V.8442a.75.75 0 0 1 1.5 0v8.6421a.75.75 0 0 1-.75.75zM6.7354 6.3955H2.1265a.75.75 0 0 1 0-1.5h4.6089a.75.75 0 0 1 0 1.5zM4.4307 15.8057a.75.75 0 0 1-.75-.75V7.95a.75.75 0 0 1 1.5 0v7.1055a.75.75 0 0 1-.75.7502z" />
      <path d="M4.4307 6.3955a.75.75 0 0 1-.75-.75V.8442a.75.75 0 0 1 1.5 0v4.8013a.75.75 0 0 1-.75.75z" />
    </g>
  );
};

export default withIcon(IconSlidersVert);
